module.exports = __webpack_public_path__ + "img/f5ceecd.jpg";